import React, { ReactType } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

interface Props {
    wrapperComponent?: ReactType;
    wrapperClassName?: string;
}

const FadeIn: React.SFC<Props> = ({ wrapperComponent, wrapperClassName, children }) => {
    return (
        <ReactCSSTransitionGroup
            transitionName={{
                enter: 'fade-in',
                leave: 'fade-out',
                appear: 'fade-in',
            }}
            transitionAppear={false}
            transitionEnter={true}
            transitionEnterTimeout={500}
            transitionAppearTimeout={500}
            transitionLeaveTimeout={300}
            component={wrapperComponent}
            className={wrapperClassName}
        >
            {children}
        </ReactCSSTransitionGroup>
    );
};

export default FadeIn;
